<template>
  <v-bottom-sheet v-model="bottomSheetOpen" @input="emitBottomSheetState">
    <v-sheet class="rounded-t-xl " height="90vh" ref="bottomSheetContent" v-hammer:swipe.down="closeBottomSheet">
      <div class="text-center" v-hammer:swipe.down="closeBottomSheet">
        <v-icon class="text-center" large @swipeup="closeBottomSheet">mdi-minus</v-icon>
      </div>
      <!-- <v-text-field ref="searchField" label="검사파트" hide-details="" v-model="searchWord" append-icon="mdi-magnify"
                class="custom-text-field mx-auto pt-2 text-field" style="width: 95%"></v-text-field> -->
      <v-container>
        <div style="height: calc(90vh - 96px);">
          <v-simple-table dense :height="listHeight">
            <template v-slot:default>
              <tbody>
                <tr tabindex="0" v-for="item, index in codePartList" :key="index">
                  <!-- <td width="10%" class="pr-0" >

                                    </td> -->
                  <td>
                    <v-checkbox color="success" dense hide-details="" v-model="selectedCodePart"
                      @click="onSelect(item.partName)" :value="item.partCode" :label="item.partName"></v-checkbox>
                    <!-- {{ item.partName }}-->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row class="mt-3" style="position: sticky; z-index: 2; bottom: 20px;">
            <v-col cols="5" class=" pt-1" @click="resetCodePart()">
              <v-btn :ripple="false" color="#e8e8e8" class="no-background-hover font-weight-bold btn-height" block
                elevation="0" large>초기화</v-btn>
            </v-col>
            <v-col cols="7" class="pl-0 pt-1">
              <v-btn block elevation="0" color="#26a05a" large dark @click="closeBottomSheet"
                class="font-weight-bold btn-height">적용</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-sheet>
  </v-bottom-sheet>
</template>
<style scoped>
::v-deep .text-field .v-label {
  font-size: 13px !important;
  margin-top: 8px;
}

::v-deep .text-field .v-text-field__slot {
  padding-top: 10px;
}

.custom-bottom-sheet {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.table-container {
  flex: 1;
  overflow-y: auto;
}
</style>
<script>
import backButton from '../backButton'
import * as testAPI from './testAPI'
import * as commonFunction from '../commonFunction'
export default {
  mixins: [
    backButton(['bottomSheetOpen'])
  ],
  props: [
    'partName',
    'codePart'
  ],

  components: {
  },

  data () {
    return {
      bottomSheetOpen: false,
      searchWord: '',
      codePartList: [],
      selectedCodePart: [],
      selectedPartName: [],
      listHeight: 0
    }
  },

  mounted () {
    if (commonFunction.isAndroid()) {
      this.listHeight = (screen.height * 0.9) - 200
    } else if (commonFunction.isIOS()) {
      this.listHeight = (screen.height * 0.9) - 130
    }
  },

  computed: {
    getUserID: function () {
      return this.$store.getters['userStore/getUserID']
    },

    getPassword: function () {
      return this.$store.getters['userStore/getPassword']
    },

    getUserInfo: function () {
      return this.$store.getters['userStore/getUserInfo']
    },

    getTestLibrary: function () {
      return this.$store.getters['testStore/getTestLibrary']
    }

  },

  created () {
    if (Object.keys(this.getTestLibrary).length !== 0 && this.getTestLibrary.codePart !== '' && this.getTestLibrary.partName !== '') {
      this.selectedCodePart = this.getTestLibrary.codePart.split(',')
      this.selectedPartName = this.getTestLibrary.partName.split(',')
    }
  },

  watch: {
    bottomSheetOpen: function () {
      if (this.bottomSheetOpen === true) {
        this.getCdoeTestPart()
        this.$emit('isOpend', true)
      } else {
        this.$emit('isOpend', false)
      }
    },

    // partName: function (newVal, oldVal) {
    //     this.selectedPartName = newVal.split(',')
    // },

    // codePart: function (newVal, oldVal) {
    //     this.selectedCodePart = newVal.split(',')
    // },

    open: function () {
      // this.$refs.search.blur();
      if (open === false && this.bottomSheetOpen === true) {
        this.bottomSheetOpen = false
      }
    },

    selectedCodePart: function () {
      // if (this.selectedCodePart[0] === '') {
      //     this.selectedCodePart = this.selectedCodePart.shift()
      // }
      this.$emit('onSelected', this.selectedCodePart)
    },

    selectedPartName: function () {
      // if (this.selectedPartName[0] === '') {
      //     this.selectedPartName = this.selectedPartName.shift()
      // }
      this.$emit('onSelectedForPartName', this.selectedPartName)
    }
  },

  methods: {
    closeBottomSheet () {
      this.$emit('isOpend', false)
      this.bottomSheetOpen = false
    },
    emitBottomSheetState () {
      this.$emit('update:bottomSheetOpen', this.bottomSheetOpen)
    },

    resetCodePart () {
      this.selectedCodePart = []
      this.selectedPartName = []
    },

    onSelect (partName) {
      if (this.selectedPartName.includes(partName) === true) {
        this.selectedPartName = this.selectedPartName.filter((element) => element !== partName)
      } else {
        this.selectedPartName.push(partName)
      }
    },

    isAll (clientName, clientID) {
      this.$emit('onSelected', { clientName, clientID })
    },

    getCdoeTestPart () { // 검사 파트 조회
      testAPI.getCdoeTestPart(this.getUserID, this.getPassword)
        .then((res) => {
          this.codePartList = res.data.result
        })
    }
  }

}
</script>
